import './main.css';
import Slider from 'react-slick';


import iconPartner from '../../assets/icons/partner.svg';
import iconExperience from '../../assets/icons/experience.svg';
import iconDesign from '../../assets/icons/design.svg';
import iconDeadline from '../../assets/icons/deadline.svg';
import iconQuality from '../../assets/icons/quality.svg';

export const mainService = [
  {
    id: 'reliable-partner',
    title: 'Надёжный партнёр для бизнеса',
    image: iconPartner
  },
  {
    id: 'experience',
    title: 'Большой опыт производства металлоизделий',
    image: iconExperience
  },
  {
    id: 'design-department',
    title: 'Свой профессиональный конструкторский отдел',
    image: iconDesign
  },
  {
    id: 'deadline',
    title: 'Выполнение заказов в строго указанные сроки',
    image: iconDeadline
  },
  {
    id: 'quality',
    title: 'Высокое качество услуг и продукции',
    image: iconQuality
  }
];


export default function Main() {
  const mainSliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
          arrows: false
        }
      }
    ]
  };
  return (
    <section id="glavnaya" className="section main-section">
      <div className="main-overlay">
        <div className="main-section-content">
          <div className="main-header-block">
            <h1 className="main-title">Металлообработка</h1>
            <p className="main-subtitle">
              Высокое качество<br />
              Разумные цены
            </p>

            <div className="main-description-container">
              <p className="main-description highlighted-text">
                Всё на современном оборудовании с ЧПУ и строгим контролем качества
              </p>

              <p className="main-description-footer">
                Лазерная резка, гибка, сварка, фрезеровка, токарная обработка, покраска
              </p>
              <p className="main-description-footer">
                Инжиниринг и проектирование
              </p>

              <p className="main-description highlighted-text">
                Контактный номер: +7 (952) 350-43-16<br />
                Электронная почта: xarmet@inbox.ru
              </p>
            </div>
          </div>

          <div className="main-services-block">
            <div className="main-services">
              <div className="service-card">
                <div className="service-icon">
                  <img src={iconPartner} alt="Надёжный партнёр" />
                </div>
                <p>Надёжный партнёр для бизнеса</p>
              </div>
              <div className="service-card">
                <div className="service-icon">
                  <img src={iconExperience} alt="Большой опыт" />
                </div>
                <p>Большой опыт производства металлоизделий</p>
              </div>
              <div className="service-card">
                <div className="service-icon">
                  <img src={iconDesign} alt="Конструкторский отдел" />
                </div>
                <p>Свой профессиональный конструкторский отдел</p>
              </div>
              <div className="service-card">
                <div className="service-icon">
                  <img src={iconDeadline} alt="Соблюдение сроков" />
                </div>
                <p>Выполнение заказов в строго указанные сроки</p>
              </div>
              <div className="service-card">
                <div className="service-icon">
                  <img src={iconQuality} alt="Высокое качество" />
                </div>
                <p>Высокое качество услуг и продукции</p>
              </div>
            </div>
          </div>
          <div className="main-slider">
          <Slider {...mainSliderSettings}>
            {mainService.map((mitem) => (
              <div className="mainslider-slide" key={mitem.id}>
                <div className="mainservices-card">
                  <img
                    src={mitem.image}
            className="mainservices-image"
            alt={mitem.title}
                  />
                  <div className="mainservices-title">{mitem.title}</div>

                </div>
              </div>
            ))}
          </Slider>
        </div>
        </div>
      </div>
    </section>
  );
} 